module.exports = __webpack_public_path__ + "media/images/konintodoke/printout/1-2-3-454fba7834463fda87662b8a735ca5b1.png";